<template>
    <div v-if="isLoaded">
        <li class="dropdown dropdown-notification nav-item"><a class="nav-link nav-link-label" href="#" data-toggle="dropdown"><i class="ficon ft-bell"></i>
            <span class="badge badge-pill badge-default badge-danger badge-default badge-up" v-if="newn>0">{{ newn }}</span></a>
            <ul class="dropdown-menu dropdown-menu-media dropdown-menu-right">
                <li class="dropdown-menu-header">
                  <h6 class="dropdown-header m-0">
                      <span class="grey darken-2">Notificações</span>
                      <span class="notification-tag badge badge-default badge-danger float-right m-0" v-if="newn>0">{{ newn }} Novos</span>
                  </h6>
                </li>
                <li class="scrollable-container media-list ps-container ps-theme-dark" v-for="n in notifications">
                    <div class="media" v-bind:class="{'bg-notification-new': n.newn}">
                        <div class="media-left align-self-center"><i :class="n.cor_fundo_icone"></i>
                        </div>
                        <div class="media-body">
                            <h6 class="media-heading red darken-1">{{ n.titulo }}</h6>
                            <p v-html="n.descr" class="notification-text font-small-3 text-muted"></p><small>
                            <time class="media-meta text-muted">{{ formatDateHora(n.dt_hr) }}</time></small>
                        </div>
                    </div>
                </li>
                <li class="dropdown-menu-footer">
                    <a class="dropdown-item text-muted text-center" href="b#/usuarioconf">Ver todas notificações</a>
                </li>
            </ul>
        </li>
    </div>
</template>
<script>

import ChatMessages from './ChatMessages';
import ChatForm from './ChatForm';
import moment from 'moment'
export default {
    components: { ChatMessages, ChatForm },
    data () {
      return {
          notifications: [],
          newn: 0,
        }
    },
    created() {

        if(this.u_notification!==undefined)
        {
            this.notifications = this.u_notification;
        }
    },
    methods: {
        formatDateHora (value, fmt = 'DD/MM/YYYY HH:mm:ss') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD HH:mm:ss').format(fmt)
        },
    },
    computed:
    {
        user:
        {
            get ()
            {
                return this.$store.state.logged.user;
            }
        },
        u_notification:
        {
            get ()
            {
                return this.$store.state.logged.notificacao;
            }
        },
        isLoaded: {
            get()
            {
                  return this.$store.getters.isloaded;
            }
        },
    }
  }
  </script>
